import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { PostCommandService } from 'pbc.angular';
import { ISelection } from 'pbc.types';

import { IPostKundenArtCommandShapes, IPostKundenArtRequest, IPostKundenArtResponse } from 'fa-kt.types';

@Injectable({
  providedIn: 'root',
})
export class PostKundenArtCommandService extends PostCommandService<IPostKundenArtRequest, IPostKundenArtResponse, IPostKundenArtCommandShapes> {
  readonly route = 'kunden/settings/kunden-art';
  override dependencies = ['kunden/written-kunden-gruppe', 'kunden/removed-kunden-gruppe'];

  async getKundenArtsKundenGruppe(value: string): Promise<ISelection | undefined> {
    return new Promise((resolve) => {
      this.kundenArtsKundenGruppe.pipe(first()).subscribe((kundenArtsKundenGruppe) => resolve(kundenArtsKundenGruppe.find((a) => a.value === value)));
    });
  }

  get kundenArtsKundenGruppe(): Observable<ISelection[]> {
    return this.shapes$.pipe(map((shapes) => (shapes ? (shapes['kundenArts.kundenGruppe'] as ISelection[]) : [])));
  }
}
